import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { ClientesDatosGeneralesVendedores } from "./ClientesDatosGeneralesVendedores";
import Swal from "sweetalert2";
import request from "../../Helpers/API";
import { types } from "../../Helpers/Types";
import { useDispatch, useSelector } from "react-redux";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography color="textPrimary">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const RegistroClienteMainScreen = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { clienteinput, clienteselected, clientesArray, disabled } =
    useSelector((store) => store.clientes);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onChangeInput = ({ value }) => {
    dispatch({
      type: types.clienteinput,
      payload: value,
    });
  };
  const onBuscar = (e) => {
    if (
      clienteinput === undefined ||
      clienteinput === null ||
      clienteinput === "" ||
      clienteinput.length === 0
    ) {
      Swal.fire(
        "Clientes",
        "Favor de ingresar la razon social o rfc del cliente a buscar",
        "error"
      );
      return;
    }

    request
      .get(`Clientes/BuscarRFCOrRazonSocial?value=${clienteinput}`)
      .then((result) => {
        dispatch({
          type: types.clientesArray,
          payload: result,
        });
        var newDiv = document.getElementById("yo");
        newDiv.click();

        var trdetalle = document.getElementById("clientes-tabla-detalle");
        if (result !== undefined && result !== null && result.length > 0) {
          var html = "";
          result.forEach((element) => {
            html += `
            <tr>
            <td id=${element.idcliente} class='${element.razon_social}'>${element.idcliente}</td>
            <td  id=${element.idcliente}  class='${element.razon_social}'>${element.razon_social}</td>
            <td  id=${element.idcliente}  class='${element.razon_social}'>${element.rfc}</td>
            </tr>
          `;
          });
          trdetalle.innerHTML = html;
        }
      })
      .catch((error) => {
        Swal.fire("REGISTRO DE CLIENTES", JSON.stringify(error), "error");
      });
  };
  const onClickConsultarCliente = (e) => {
    const idcliente = e.target.id;
    const razonsocial = e.target.className;

    dispatch({
      type: types.clientes,
      payload: {
        clienteinput: "",
        clienteselected: razonsocial,
        idcliente: idcliente,
        clientesArray,
        disabled: false,
      },
    });

    document.getElementById("mdlclientessearchclose").click();
  };
  const onAgregarCliente = () => {
    dispatch({
      type: types.clientes,
      payload: {
        clienteinput: "",
        clienteselected,
        idcliente: 0,
        clientesArray,
        disabled: false,
      },
    });
    document.getElementById("mdlclientessearchclose").click();
  };
  return (
    <div id="clientes-container" className="main-container">
      {loading === true && (
        <div id="loading-clientes" className="spinner">
          <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}

      <div className="clientes-container-header">
        <div className="clientes-container-header-titulo">
          <div className="clientes-container-header-titulo-texto">
            REGISTRO DE CLIENTES 
          </div>
        </div>
        <div className="clientes-container-header-footer"></div>
      </div>
      <div className="clientes-container-resumen-search">
        <label>RFC O RAZON SOCIAL</label>
        <div className="clientes-container-resumen-search-button">
          <input
            type="text"
            id="search-cliente"
            value={clienteinput}
            onChange={({ target }) => onChangeInput(target)}
          />
          <a onClick={onBuscar}>BUSCAR</a>
          <a className="d-none" id="yo" href="#modalsearchcliente">
            BUSCAR
          </a>
        </div>
      </div>
      <div className="clientes-container-detalle">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab color="primary" label="Datos Generales" {...a11yProps(0)} />
            {/* <Tab label="Solicitud de Credito" {...a11yProps(6)} /> */}
            {/* <Tab label="Estado de cuenta" {...a11yProps(4)} /> */}
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ClientesDatosGeneralesVendedores disabled={disabled} setLoading={setLoading} />
        </CustomTabPanel>
      </div>
      <div id="modalsearchcliente" class="modalmask">
        <div class="modalbox resize">
          <a
            id="mdlclientessearchclose"
            href="#close"
            title="Close"
            class="close"
          >
            X
          </a>
          <h2>Resultados de la busqueda</h2>
          <div className="clientes-search-table scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Razon Social</th>
                  <th>RFC</th>
                </tr>
              </thead>
              <tbody
                onClick={onClickConsultarCliente}
                id="clientes-tabla-detalle"
              ></tbody>
            </table>
          </div>
          <div
            className="clientes-registrar-nuevo"
            onClick={() => onAgregarCliente()}
          >
            Registrar Nuevo Cliente
          </div>
        </div>
      </div>
    </div>
  );
};
